// extracted by mini-css-extract-plugin
export default {"wrapper":"cookieBannerPanelSection_wrapper","isRow":"cookieBannerPanelSection_isRow","noMargin":"cookieBannerPanelSection_noMargin"};